export const Role = {
    Admin: 'ADMIN',
    Director: 'DIRECTOR',
    Floater: 'FLOATER',
    Super: 'SUPER',
}